import { mergeAttributes, Node, type NodeViewProps } from "@tiptap/core";
import { ReactNodeViewRenderer, NodeViewWrapper } from "@tiptap/react";

import { Poll } from "@/ui/poll";
import { Suspense } from "react";

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		poll: {
			/**
			 * Set media
			 */
			setPoll: (options: { id: string }) => ReturnType;
		};
	}
}

function PollRenderer(props: NodeViewProps) {
	if (!props.node.attrs.id || typeof props.node.attrs.id !== "string") {
		return null;
	}

	return (
		<NodeViewWrapper>
			<Suspense
				fallback={
					<div className="h-36 w-full max-w-[420px] animate-pulse rounded-md border border-card bg-card" />
				}
			>
				<Poll
					id={props.node.attrs.id}
					editable={props.editor.isEditable}
					onDelete={() => props.deleteNode()}
				/>
			</Suspense>
		</NodeViewWrapper>
	);
}

export const PollExtension = Node.create({
	name: "poll",

	group: "block",

	atom: true,

	addAttributes() {
		return {
			id: {
				default: "",
			},
		};
	},

	addCommands() {
		return {
			setPoll:
				(options) =>
				({ commands }) => {
					return commands.insertContent({
						type: this.name,
						attrs: options,
					});
				},
		};
	},

	parseHTML() {
		return [
			{
				tag: "poll",
			},
		];
	},

	renderHTML({ HTMLAttributes }) {
		return ["poll", mergeAttributes(HTMLAttributes)];
	},

	addNodeView() {
		return ReactNodeViewRenderer(PollRenderer);
	},
});
